import { render, staticRenderFns } from "./ProductAmountDetail.vue?vue&type=template&id=38053729&"
import script from "./ProductAmountDetail.vue?vue&type=script&lang=ts&"
export * from "./ProductAmountDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports